import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { ICustomTextEntry } from '../custom_text_interface';
import { CustomTextModel } from '../models/custom_text_model';
import * as _4 from 'lodash4';

angular
  .module('data-ng-custom-text')
  .factory(
    'loadAllCustomTextCommand',
    ($http: ng.IHttpService, defineCommand: IDefineCommand, ngCustomTextModel: CustomTextModel, log: any): ICommand => {
      return defineCommand('loadAllCustomTextCommand', (deferred: ng.IDeferred<IQuery[]>): ng.IPromise<void> => {
        return $http({
          method: 'GET',
          url: `config/customtext`
        })
          .then(({ data }: any) => {
            deferred.resolve(data);
            ngCustomTextModel.write(data as ICustomTextEntry[]);
            const selfAlertIntroText: ICustomTextEntry = _4.find(data, (entry) => {
              return entry.nk === 'SELF_ALERT_INTRO_TEXT';
            });
            if (!_4.isEmpty(selfAlertIntroText)) {
              localStorage.setItem('eab.navigate.self_alert_intro_text', JSON.stringify(selfAlertIntroText.text));
            }
          })
          .catch((e: any) => {
            log.issue('Failed to get custom text');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/commands/load_all_custom_text_command.ts